<template>
  <!-- for scroll position -->
  <section class="section !pt-8 no-shadow publicationFilters ">
    <div class="container !pt-0">
      <div class="columns is-mobile is-multiline">
        <div class="column w-full lg:w-3/12">
          <SideSearchBar />
        </div>
        <div class="column w-full lg:w-8/12 lg:ml-1/12">
          <p
            id="scrollToHere"
            class="h5 mb-2"
          >
            Your search: {{ dataStats.page?.totalRecord ?? 'No' }} datasets found
          </p>
          <div class="is-flex download-query-search-bar">
            <div class="contentWrap !max-w-none w-full">
              <div class="control is-flex is-expanded searchWrap w-full lg:w-7/12">
                <selection-input
                  v-model="queryParam.searchText"
                  :label="$t('common.search')"
                  @update:model-value="updateSearchKey"
                />
              </div>
            </div>
            <div class="control is-expanded sort-select dataDownloadFilter">
              <div class="control is-expanded sort-select">
                <basic-dropdown
                  v-model="queryParam.sortBy"
                  :options="sortOptions"
                  :label="$t('publication.column.sortBy')"
                  @update:model-value="updateFilter"
                />
              </div>
            </div>
          </div>
          <div
            class="pt-4 flex flex-col md:flex-row md:justify-between items-start md:items-center jumpHere"
            style="padding-left: 20px"
          >
            <!-- <p class="h6">
              {{ dataStats.page?.totalRecord ?? 'No' }} datasets found
            </p> -->
            <div v-show="hasActiveFilters">
              <span
                class="clear-filter "
                @click="clearAllFilter"
              > {{ $t('common.clearFilter') }}
                <a
                  class="close-button"
                  aria-label="clear filter"
                ><DarkCloseIcon @click="clearAllFilter" /></a>
              </span>
            </div>
          </div>
          <div
            v-show="hasActiveFilters"
            class="pb-2 border-0 border-b-2 border-solid border-gray-medium "
          >
            Filtered By:
            <ShowQueryOptionList
              :lookup-label="tagOptions?.dataType"
              :selection="queryParam?.dataType"
              :class-style="'filter dataType'"
              :remove-item="removeSingleQueryItem"
            />
            <ShowQueryOptionList
              :lookup-label="tagOptions?.subjectAreas"
              :selection="queryParam?.subjectAreas"
              :class-style="'filter subjectAreas'"
              :remove-item="removeSingleQueryItem"
            />
            <ShowQueryOptionList
              :lookup-label="tagOptions?.tags"
              :selection="queryParam?.tags"
              :class-style="'filter tags'"
              :remove-item="removeSingleQueryItem"
            />
            <template
              v-for="(fieldLabel, fieldKey) in dataPortalDisplayLabelForQuery"
              :key="'query' + fieldKey"
            >
              <ShowQueryText
                :field-key="fieldKey"
                :label="fieldLabel"
                :query-param="queryParam"
                :clear-query-item="clearQueryItem"
                :class-style="'tag is-light filter search-term'"
              />
            </template>
          </div>
          <template
            v-for="(data, index) in dataList"
            :key="'data' + index"
          >
            <div v-if="data.description && data.description.trim() !== ''">
              <SingleDatasetItem
                :item="data"
                :is-list-mode="isListMode"
                :child-page-url="childPageUrl"
                :search-text="queryParam.searchText"
                :additional-action="() => scrollToTopWithOffset('#scrollToHere', 100)"
              />
            </div>
            <!-- <div>{{ data }}</div> -->
          </template>
          <div class="h3" v-if="!dataList || dataList?.length === 0">
            {{ $t("publication.list.empty") }}
          </div>
          <common-pagination
            :total-page-in-view="pageInView"
            :total-page="dataStats.page?.totalPage ?? 1"
            :current-page-number="queryParam?.page ?? 1"
            :additional-action="() => scrollToTopWithOffset('#scrollToHere', 100)"
            :update-page="updatePage"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { dataDownloadSearchState } from '@/composables/state/dataDownloadSearchApp';
import SingleDatasetItem from './SingleDatasetItem.vue';
import SideSearchBar from './SideSearchBar.vue';
// import FilterHeader from '../../components/FilterHeader.vue';
import SelectionInput from '../../components/search/SelectionInput.vue';
import ShowQueryOptionList from '../../components/ShowQueryOptionList.vue';
import ShowQueryText from '../../components/ShowQueryText.vue';
import CommonPagination from '../../components/CommonPagination.vue';
import BasicDropdown from '../../components/dropdown/BasicDropdown.vue';
import { sortOptions, dataPortalDisplayLabelForQuery } from '@/config/index';
import DarkCloseIcon from '@/assets/close-dark.svg';
import { scrollToTopWithOffset } from '@/config/common';

// const WEB_HOME_URL = import.meta.env.VITE_APP_HOME_URL ?? '';
defineProps({
  childPageUrl: { type: String, default: '' }
});

const {
  tagOptions, dataList, queryParam, dataStats, updatePage, clearAllFilter, removeSingleQueryItem, clearQueryItem, updateFilter
} = dataDownloadSearchState();
  // const searchKey = ref('');

const updateSearchKey = (e:string) => {
  queryParam.value.page = 1;
  queryParam.value.searchText = e;
};

const pageInView = 5;

const hasActiveFilters = computed(() => {
  return (queryParam.value.tags?.length ?? 0) > 0 ||
      (queryParam.value.subjectAreas?.length ?? 0) > 0 ||
      (queryParam.value.dataType?.length ?? 0) > 0 ||
      (queryParam.value.years?.length ?? 0) > 0 ||
      (queryParam.value.searchText?.length ?? 0) > 0;
});

const isListMode = ref(false);
// const showFilterMode = ref(true);

</script>
<style lang="postcss" scoped>
.align-bottom {
  align-items: flex-end;
}

div.jumpHere p.h6 {
  padding-left: 20px;
}

div.pb-2.border-0.border-b-2.border-solid.border-gray-medium {
  padding-left: 20px;
}

.sort-select {
  width: 270px;
}
.control.is-flex.is-expanded.searchWrap {
  width: 80% !important;
}

@media only screen and (max-width: 500px) {
  .download-query-search-bar {
    flex-direction: column;
    gap: 0.4lh;
  }
}
</style>
